'use strict';

function LoansNavigation() {
  this.id = null;
  this.node = null;
  this.declaredClass = null;
  this.extends = [_MoneyController];

  this._initialized = false;

  this.init = function () {
    this._super();
  };

  this.initAllReady = function () {
    this._super();
  };

  this.initPage = function () {
    this._initialized = true;
    this.updateNavigationRoute();
  };

  this.updateNavigationRoute = function () {
    if (!this._initialized) return;

    var url = this.determineMoneyRoute();
    var link = $(this.node).find('a')[0];
    var history = new History();
    if (url === this.paths.loans.fs) {
      history.removeHistoryNode(link);
      $(link).attr('href', url);
    } else {
      var currentUrl = $(link).prop('href').split(window.location.origin)[1];
      if (currentUrl !== url) {
        history.removeHistoryNode(link);
        history.addHistoryNode(link, url);
      }
    }
  };

  this.destroy = function () {
    this._super();
  };
}